export const buttonColorClasses = [
  'secondary-400',
  'primary-800',
  'primary-400',
  'secondary-600',
  'primary-500',
  'secondary-300',
  'secondary-400',
  'primary-400',
  'secondary-600',
  'primary-500',
  'primary-800',
  'secondary-300',
  'primary-800',
  'secondary-400',
  'primary-400',
  'secondary-600',
  'primary-500',
  'secondary-300',
  'primary-800',
  'secondary-400',
  'primary-400',
  'secondary-600',
  'primary-500',
  'secondary-300',
];

export const buttonBackgroundClasses = buttonColorClasses.map(
  (color) => `bg-${color}`
);

export const buttonInvertedClasses = buttonColorClasses.map(
  (color) => `border-${color} text-${color}`
);
